export const en = {
    hello : 'Hello'
};
